export const InjectTokens = {
  Tenant: Symbol('tenant'),
  DynamoTableName: Symbol('dynamoTableName'),
  JobUploadsBucket: Symbol('jobUploadsBucket'),
  JobDetailsBucket: Symbol('jobDetailsBucket'),
  JobStartQueueUrl: Symbol('jobStartQueueUrl'),
  Logger: Symbol('logger'),
};
